import OrderHandler from "../OrderHandler";
import Address from "../../../Models/Address";
import Mediator from "../../../Utilities/Mediator";

export default class CustomerAddress {
	deliverHome: HTMLDivElement;
	total: number;
	deliverHomeCheckBox: HTMLInputElement;
	addressForm: HTMLDivElement;
	address: Address;
	country: HTMLInputElement;

	constructor() {
		this.deliverHome = document.querySelector(".bill-total > .deliver-home");

		if (this.deliverHome) {
			this.init();
		}
	}

	private init() {
		this.deliverHomeCheckBox = this.deliverHome.querySelector('#deliver-home');
		this.addressForm = this.deliverHome.querySelector(':scope > div:nth-child(2)');
		this.country = this.addressForm.querySelector(':scope > div:nth-of-type(2) > div:nth-child(3) > input');
		this.address = new Address();

		this.address.country = this.country.value;
		this.addAddressChangesListeners();
		this.addAddressFormChangeListeners();
	}

	private addAddressChangesListeners() {
		this.deliverHomeCheckBox.onchange = () => {
			this.addressForm.style.display = this.deliverHomeCheckBox.checked ? "block" : "none";
			Mediator.emit("togglePickup");
			this.validateAddress();
			Mediator.emit("orderStateChanged");
		}
	}

	private addAddressFormChangeListeners() {
		const street: HTMLInputElement = this.addressForm.querySelector(':scope > div:nth-of-type(1) > input');
		street.onchange = () => {
			this.address.street = street.value;
			this.validateAddress();
		}

		const postalCode: HTMLInputElement = this.addressForm.querySelector(':scope > div:nth-of-type(2) > div:nth-child(1) > input');
		postalCode.onchange = () => {
			this.address.postalCode = postalCode.value;
			this.validateAddress();
		}

		const city: HTMLInputElement = this.addressForm.querySelector(':scope > div:nth-of-type(2) > div:nth-child(2) > input');
		city.onchange = () => {
			this.address.city = city.value;
			this.validateAddress();
		}

		this.country.onchange = () => {
			this.address.country = this.country.value;
			this.validateAddress();
		}

		const notes: HTMLInputElement = this.addressForm.querySelector(':scope > div:nth-of-type(3) > input');
		notes.onchange = () => {
			this.address.notes = notes.value;
		}
	}

	private validateAddress() {
		if (this.deliverHomeCheckBox.checked && this.isValidAddress) {
			OrderHandler.order.customerAddress = this.address;
		} else {
			OrderHandler.order.customerAddress = null;
		}

		Mediator.emit("orderStateChanged");
	}

	private get isValidAddress(): boolean {
		const addressInputs = this.addressForm.getElementsByTagName("input");

		for (var i = 0; i < addressInputs.length; i++) {
			if (!addressInputs[i].checkValidity()) {
				return false;
			}
		}

		return true;
	}
}
